import {
  LOAD_ASSETS,
  LOAD_ASSETS_SUCCESS,
  LOAD_ASSETS_ERROR,
} from "../Types/assets.constants";

const INITIAL_STATE = {
  loading: false,
  assets: [],
  error: null,
};

export const assetsListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOAD_ASSETS:
      return { ...state, loading: true, assets: [] };
    case LOAD_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        assets: action.payload,
      };
    case LOAD_ASSETS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
